export namespace En {
    export function factory() {
        return {
            header: {
                home: 'Home',
                property: 'Properties',
                blog: 'Blogs',
            },
            footer: {
                admin: ' Admin ',
                copyright: 'Copyright © 2019 Powered by RIFO',
            },
            breadCrumb: {
                l1: 'Home',
                l2_0: 'Blogs',
                l2_1: 'Properties',
                l3_0: 'Blog Detail',
                l3_1: 'Property Detail',
            },
            blog: {
                read: 'Read',
                popTitle: 'Popular Blogs',
                pop: 'HOT'
            },
            agentCard: {
                contact: 'Contact Me',
                name: 'Name',
                phone: 'Phone',
                email: 'Email',
                date: 'Date',
                morning: 'Morning',
                noon: 'Noon',
                afternoon: 'Afternoon',
                notes: 'Message',
                submit: 'Submit',
                today: 'Today',
                tomorrow: 'Tomorrow',
                appointment: 'Appointment'
            },
            propertyDetails: {
                title: 'Property Details',
                propertySummary: {
                    community: 'Community',
                    crossStreets: 'Cross Street',
                    taxes: 'Tax',
                    maintFee: 'Management Fee',
                    monthPay: 'Monthly Pay'
                },
                cost: {
                    title: 'Cost',
                    '1': 'Land Transfer Tax',
                    '2': 'First Time Buyer',
                    '3': 'Not First Time',
                    '4': 'Mortgage',
                    '5': 'Total',
                    '6': 'Down Payment',
                    '7': 'Monthly Payment',
                    '8': '20% Down Payment，25-Year Total，5-Year Variable，2.25% Rates',
                },
                desc: {
                    title: 'Description'
                },
                schoolInfo: {
                    title: 'School Infomation',
                    titlePrimary: 'Primary (JK - G8)',
                    titleSecondary: 'Secondary (G9 - G12)',
                    rankTitle: 'Fraser(2019)'
                },
                roomsInfo: {
                    title: 'Rooms',
                    roomsFields: {
                        name: 'Name',
                        feet: 'Feet',
                        meter: 'Meter',
                        features: 'Features'
                    },
                },
                disclaimer: {
                    title: 'Disclaimer'
                },
                propertyMap: {
                    title: 'Map',
                    showStreetView: 'View',
                    showMap: 'Map'
                },
                summaryInfo: {
                    title: 'Summary',
                    fileds: {
                        id: 'Listing ID#',
                        zoning: 'Zoning',
                        ownership: 'Ownership',
                        propertyType: 'Property Type',
                        dom: 'Days Of Marketing',
                        type: 'Listing Type',
                        city: 'City',
                        community: 'Community',
                        garages: 'Garages',
                        parkings: 'Parking Spaces',
                        lotArea: 'Lot Area',
                        usageArea: 'Usage Area',
                        buildingArea: 'Building Area',
                        apxAge: 'Approximate Age',
                        builtYear: 'Built Year',
                        maintFee: 'Maintainance Fee',
                        frontOn: 'Front On',
                        storeys: 'Storeys',
                        occupancyDate: 'Occupancy Date',
                        brokerage: 'Brokerage'
                    }
                },
                detailInfo: {
                    title: 'Detail',
                    fileds: {
                        price: 'Price',
                        priceUnit: 'Price Unit',
                        fullAddress: 'Address',
                        bedrooms: 'Bedrooms',
                        bedroomsPlus: 'Bedroom Plus',
                        washrooms: 'Bathrooms',
                        otherFee: 'Other Fee',
                        openHouse: '房源开放日',

                        utilityIncludes: 'Utility Includes',
                        utilityFeatures: 'Utility Features',
                        tax: 'Taxes',
                        condoFeatures: 'Condo Features',
                        otherFeatures: 'Other Features',
                        poolInfo: 'Pool',
                        basements: 'Basements',
                        crossStreets: 'Cross Streets'
                    }
                },
                qrCode: {
                    wechatContent: 'Scan to share on wechat'
                }
            },
            propertyList: {
                title: 'Properties',
                all: 'All Properties'
            },
            blogList: {
                title: 'Blogs',
                all: 'All Blogs'
            },
            aboutMe: {
                title: 'About Me'
            },
            socialMedia: {
                '1': 'Share'
            },
            contactForm: {
                '1': 'Name',
                '2': 'Phone Number',
                '3': 'Email',
                '4': 'Remark',
            },
        };
    }
}
